import Property from "../../store/models/household/Property";
import axios from "axios";

export default {
    namespaced: true,

    getters: {
        properties() {
            return Property.all();
        },
        householdProperties() {
            return (householdId) => {
               return Property
                    .query()
                    .where('household_id', householdId)
                    .get();
            }
        },
        getHouseholdPropertiesWithBeneficiaries() {
            return (householdId) => {
                return Property
                    .query()
                    .withAllRecursive()
                    .where('household_id', householdId)
                    .get();
            }
        },
        getProperty() {
            return (id) => Property.find(id);
        }
    },

    actions: {
        loadProperties({commit}, {householdId}) {
            return axios
                .get(`api/household/${householdId}/properties`)
                .then((response) => {
                        commit('PROPERTIES_LOADED', response.data.data.properties);
                        return response;
                    }
                );
        },
    },

    mutations: {
        ['PROPERTIES_LOADED'](state, data) {
            if (data) {
                Property.create({data});
            }
        },
    }
}
